import { render, staticRenderFns } from "./SubHeaderBase.vue?vue&type=template&id=36346bc8&scoped=true&"
import script from "./SubHeaderBase.vue?vue&type=script&lang=js&"
export * from "./SubHeaderBase.vue?vue&type=script&lang=js&"
import style0 from "./SubHeaderBase.vue?vue&type=style&index=0&id=36346bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36346bc8",
  null
  
)

export default component.exports